export default __webpack_public_path__ + "static/media/STL-Investors-Meet11062025.8f962a08.pdf";